import { Badge, Button, Flex } from 'antd';

import translations from './VisualValidationActionButtons.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import styled from 'styled-components';
import { colorPrimary, colorYellow } from '@atlas-frontend/design-tokens';
import { ClearButton } from '@atlas-frontend/sdk';

const { addTranslations, t } = i18nNsFactory(
  'visual-validation-action-buttons',
);
addTranslations(translations);

type CommentsProps =
  | { onCommentsClick?: undefined; hasDescription?: never; hasComments?: never }
  | {
      onCommentsClick: () => void;
      hasDescription: boolean;
      hasComments: boolean;
    };

type AlgorithmsProps =
  | { onAlgorithmsClick?: undefined }
  | { onAlgorithmsClick: () => void };

type SourcesProps =
  | { onSourcesClick?: undefined; hasVersions?: never }
  | { onSourcesClick: () => void; hasVersions: boolean };

type NewDashboardProps =
  | { onNewDashboardClick?: undefined; isLoading?: never }
  | { onNewDashboardClick: () => void; isLoading?: boolean };

type ClearFiltersProps =
  | { filtersCount?: undefined; onFilterClear?: undefined }
  | { filtersCount: number; onFilterClear: () => void };

export type Props = CommentsProps &
  SourcesProps &
  AlgorithmsProps &
  NewDashboardProps &
  ClearFiltersProps;

export const VisualValidationActionButtons = ({
  hasDescription,
  hasVersions,
  hasComments,
  onCommentsClick,
  onSourcesClick,
  onAlgorithmsClick,
  onNewDashboardClick,
  filtersCount,
  onFilterClear,
  isLoading,
}: Props) => {
  return (
    <Flex gap="small" wrap="wrap" align="flex-end">
      {onCommentsClick && (
        <Button
          id="comments"
          onClick={onCommentsClick}
          disabled={!hasDescription}
        >
          {t('comments')}
          {hasComments && <Badge color={colorPrimary} />}
        </Button>
      )}
      {onAlgorithmsClick && (
        <Button
          id="algorithms"
          onClick={onAlgorithmsClick}
          disabled={!hasVersions}
        >
          {t('algorithms')}
        </Button>
      )}
      <Button id="sourceData" onClick={onSourcesClick} disabled={!hasVersions}>
        {t('sourceData')}
      </Button>
      {onNewDashboardClick && (
        <NewDashboardButton
          id="newDashboard"
          onClick={onNewDashboardClick}
          disabled={isLoading}
          loading={isLoading}
        >
          {t('newDashboard')}
        </NewDashboardButton>
      )}
      {!!filtersCount && filtersCount > 0 && (
        <ClearButton
          id="clear-filters"
          count={filtersCount}
          onClick={onFilterClear}
          label={t('clearFilters')}
        />
      )}
    </Flex>
  );
};

const NewDashboardButton = styled(Button)`
  background-color: ${colorYellow[1]};
`;
